export default __webpack_public_path__ + "img/sagoo/sagoo8_480.jpg";